import React from 'react';
import styled from '@emotion/native';
import { BaseText } from '@/shared/components/StyledText';
import { green, mint } from '@/shared/styles/colors';
import { ConsultationStatus } from '@/shared/types/generated';

const ComeBackText = ({ status }: { status: ConsultationStatus }) => {
  if (status !== ConsultationStatus.Upcoming) return null;

  return (
    <ComeBackContainer>
      <StyledText>Come back at the time of the meeting to join</StyledText>
    </ComeBackContainer>
  );
};

const StyledText = styled(BaseText)({
  fontSize: 13,
  color: green,
  fontWeight: 'bold',
});

const ComeBackContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: 48,
  backgroundColor: mint,
  width: '100%',
  marginBottom: 22,
});

export default ComeBackText;
